export enum MealType {
    none = 'NONE',
    hot = 'HOT',
    bread = 'BREAD',
}
